import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "1000"
    },
    on: {
      "close": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.migration.title')) + "\n    "), _c('div', {
          staticClass: "text-subtitle-1 font-weight-regular migration-subtitle"
        }, [_vm._v(_vm._s(_vm.subtitle))])];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function () {
        return [_c('span', {
          staticClass: "text-body-2 flex-grow-1 pr-4"
        }, [_vm._v(_vm._s(_vm.footerText))]), _c('core-button', {
          attrs: {
            "color": "danger",
            "prepend-icon": "fa-times"
          },
          on: {
            "click": _vm.close
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.cancel')) + "\n    ")]), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-exchange",
            "loading": _vm.isStarting,
            "disabled": !_vm.canStart,
            "data-cy": "migration_start"
          },
          on: {
            "click": _vm.start
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.migration.start')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_vm.isLoadingPreview ? _c(VProgressLinear, {
    staticClass: "mb-4",
    attrs: {
      "indeterminate": "",
      "color": _vm.color
    }
  }) : _vm._e(), _vm.previewError ? _c(VAlert, {
    staticClass: "mb-4",
    attrs: {
      "type": "error",
      "border": "left",
      "colored-border": "",
      "elevation": "1",
      "dense": "",
      "icon": false
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c(VIcon, {
    staticClass: "mr-3 flex-shrink-0",
    attrs: {
      "color": "error"
    }
  }, [_vm._v("fal fa-exclamation-triangle")]), _c('span', [_vm._v(_vm._s(_vm.previewError))])], 1)]) : _vm._e(), _vm.preview ? [_c('h4', {
    staticClass: "migration-section"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.migration.sections.target')))]), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "items": _vm.accounts,
      "label": _vm.$i18n_t('NiotaClassic.Applications.migration.account'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "data-cy": "migration_account"
    },
    model: {
      value: _vm.selectedAccount,
      callback: function ($$v) {
        _vm.selectedAccount = $$v;
      },
      expression: "selectedAccount"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSelect, {
    staticClass: "required",
    attrs: {
      "items": _vm.fireflyBridgeItems,
      "label": _vm.$i18n_t('NiotaClassic.Applications.migration.connector'),
      "hint": _vm.$i18n_t('NiotaClassic.Applications.migration.connectorHint'),
      "disabled": _vm.fireflyBridgeItems.length === 0,
      "loading": _vm.isLoadingTenant,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "persistent-hint": "",
      "data-cy": "migration_connector"
    },
    model: {
      value: _vm.selectedBridgeId,
      callback: function ($$v) {
        _vm.selectedBridgeId = $$v;
      },
      expression: "selectedBridgeId"
    }
  }), _vm.showNoConnectorHint ? _c('p', {
    staticClass: "error--text text-caption mt-1 mb-0"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.migration.noConnector')) + "\n        ")]) : _vm._e()], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-dtwin-finder', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Applications.migration.parent'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "tenantId": _vm.selectedAccount,
      "objectFilter": _vm.parentSelectorFilter,
      "loadFullDtwinData": false,
      "sameTenant": "",
      "required": "",
      "hideDetails": ""
    },
    model: {
      value: _vm.parentId,
      callback: function ($$v) {
        _vm.parentId = $$v;
      },
      expression: "parentId"
    }
  }), _c('p', {
    staticClass: "text-caption mt-1 mb-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.migration.parentHint')))])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VCombobox, {
    attrs: {
      "items": _vm.groupItems,
      "label": _vm.$i18n_t('NiotaClassic.Applications.migration.groups'),
      "hint": _vm.$i18n_t('NiotaClassic.Applications.migration.groupsHint'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "multiple": "",
      "persistent-hint": "",
      "data-cy": "migration_groups"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function ({
        item,
        selected
      }) {
        return [_c(VChip, {
          attrs: {
            "small": "",
            "input-value": selected,
            "close": ""
          },
          on: {
            "click:close": function ($event) {
              return _vm.removeGroup(item);
            }
          }
        }, [_c('span', [_vm._v(_vm._s(item))]), _vm.isNewGroup(item) ? _c(VChip, {
          staticClass: "ml-1 white--text",
          attrs: {
            "x-small": "",
            "color": _vm.color,
            "data-cy": "new_group"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.migration.newGroup')) + "\n              ")]) : _vm._e()], 1)];
      }
    }], null, false, 3354832534),
    model: {
      value: _vm.groups,
      callback: function ($$v) {
        _vm.groups = $$v;
      },
      expression: "groups"
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex justify-space-between align-end mt-6 mb-2"
  }, [_c('h4', {
    staticClass: "migration-section mb-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.migration.sections.mapping')))]), _c('span', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s(_vm.mappingStatusText))])]), _c(VSimpleTable, {
    staticClass: "migration-mapping",
    attrs: {
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.migration.mappingSource')))]), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.migration.mappingTarget')))])])]), _c('tbody', _vm._l(_vm.deviceTypeRows, function (row) {
    return _c('tr', {
      key: row.key
    }, [_c('td', {
      staticClass: "py-2"
    }, [_c('div', {
      staticClass: "font-weight-medium"
    }, [_vm._v(_vm._s(row.title))]), _c('div', {
      staticClass: "text-caption"
    }, [_vm._v("\n              " + _vm._s(_vm.$i18n_tc('NiotaClassic.Applications.migration.devicesOfType', row.deviceCount, {
      id: row.id === null ? '-' : row.id,
      n: row.deviceCount
    })) + "\n            ")])]), _c('td', {
      staticClass: "py-2"
    }, [row.id === null ? [_c('span', {
      staticClass: "text-caption"
    }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.migration.mappingNoDriverHint')) + "\n              ")])] : [_c(VSelect, {
      attrs: {
        "value": _vm.mapping[row.key],
        "items": _vm.driverItems,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "dense": "",
        "hide-details": "",
        "data-cy": `migration_driver_${row.key}`
      },
      on: {
        "change": function ($event) {
          return _vm.setMapping(row.key, $event);
        }
      }
    }), _c('span', {
      staticClass: "text-caption"
    }, [_vm._v(_vm._s(_vm.mappingCaption(row)))])]], 2)]);
  }), 0)]), _c('h4', {
    staticClass: "migration-section mt-6"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.migration.sections.options')))]), _vm._l(_vm.importOptionRows, function (option) {
    return _c('div', {
      key: option.key,
      staticClass: "migration-option d-flex align-center"
    }, [_c('div', {
      staticClass: "flex-grow-1"
    }, [_c('div', {
      staticClass: "font-weight-medium"
    }, [_vm._v(_vm._s(option.label))]), _c('div', {
      staticClass: "text-caption"
    }, [_vm._v(_vm._s(option.hint))])]), _c(VSwitch, {
      staticClass: "mt-0 pt-0",
      attrs: {
        "color": _vm.color,
        "inset": "",
        "hide-details": "",
        "data-cy": `migration_import_${option.key}`
      },
      model: {
        value: _vm.importOptions[option.key],
        callback: function ($$v) {
          _vm.$set(_vm.importOptions, option.key, $$v);
        },
        expression: "importOptions[option.key]"
      }
    })], 1);
  }), _c('div', {
    staticClass: "migration-option"
  }, [_c('div', {
    staticClass: "font-weight-medium mb-1"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.migration.operationalStatus')) + "\n      ")]), _c(VRadioGroup, {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.statusMode,
      callback: function ($$v) {
        _vm.statusMode = $$v;
      },
      expression: "statusMode"
    }
  }, [_c(VRadio, {
    attrs: {
      "value": "keep",
      "color": _vm.color,
      "label": _vm.keepStatusLabel,
      "data-cy": "migration_status_keep"
    }
  }), _c('div', {
    staticClass: "d-flex align-center mt-2"
  }, [_c(VRadio, {
    staticClass: "mb-0",
    attrs: {
      "value": "set",
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Applications.migration.setStatus'),
      "data-cy": "migration_status_set"
    }
  }), _c(VSelect, {
    staticClass: "migration-status-select ml-4",
    attrs: {
      "items": _vm.statusItems,
      "disabled": _vm.statusMode !== 'set',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.statusValue,
      callback: function ($$v) {
        _vm.statusValue = $$v;
      },
      expression: "statusValue"
    }
  })], 1)], 1)], 1), _vm._l(_vm.notices, function (notice, index) {
    return _c(VAlert, {
      key: notice.key,
      class: index === 0 ? 'mt-4 mb-2' : 'mb-2',
      attrs: {
        "color": notice.color,
        "border": "left",
        "colored-border": "",
        "elevation": "1",
        "dense": "",
        "icon": false,
        "data-cy": `migration_notice_${notice.key}`
      }
    }, [_c('div', {
      staticClass: "d-flex align-center"
    }, [_c(VIcon, {
      staticClass: "mr-3 flex-shrink-0",
      attrs: {
        "color": notice.color
      }
    }, [_vm._v(_vm._s(notice.icon))]), _c('span', [_vm._v(_vm._s(notice.text))])], 1)]);
  })] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };